import Btn from '@componentPrimitives/Btn';
import Flex from '@componentPrimitives/Flex';
import Grid from '@componentPrimitives/Grid';
import Txt from '@componentPrimitives/Txt';
import Card from '@components/Card';
import { EventTicketedCardProps } from '@components/EntryCard/EntryCard.EventTicketed';
import { useEvent } from '@lib/hooks';
import { parseHref } from '@liquorice/allsorts-craftcms-nextjs';
import { useTranslations } from 'next-intl';

const TicketIndexFeaturedCard = ({ item, ...props }: EventTicketedCardProps) => {
  const t = useTranslations('cta');

  const {
    title,
    entrySummary: summary,
    uri,
    entryImage: image,
    buyTicketsLink,
    eventPrice,
    eventPricePrefix,
  } = useEvent(item);

  const href = parseHref(uri).href;

  if (!item) return <></>;

  return (
    <Card
      padding="lg"
      item={{
        title,
        description: summary,
        image,
      }}
      {...props}>
      <Grid>
        <Grid.Col lg={6}>
          <Card.Image ratio="landscape" transform="landscapeSmCrop" />
        </Grid.Col>
        <Grid.Col lg={6}>
          <Card.Body>
            <Card.Title variant="h3" />
            <Card.Description maxChars={100} />
            <Txt variant="bodyAlt" color="secondaryContrast" cx={{ mB: 'none' }}>
              {eventPricePrefix}
            </Txt>
            <Txt variant="h3" color="secondaryContrast" cx={{ mB: 'sm' }}>
              {eventPrice}
            </Txt>
            <Flex alignItems="center" spacing="lg" cx={{ width: 'full' }}>
              <Btn {...buyTicketsLink} fullWidth variant="filled" color="primary" />
              {href && (
                <Btn variant="text" href={href} underline="none" size="small">
                  {t('discover')}
                </Btn>
              )}
            </Flex>
          </Card.Body>
        </Grid.Col>
      </Grid>
    </Card>
  );
};

export default TicketIndexFeaturedCard;
